<template>
  <d2-container type="ghost"  v-if="is_ygs=='0'" class="home">
    <el-row type="flex" align="center" class="home__row">
      <el-col :span="12">
        <div class="home__wapper">
          <OverView />
        </div>
      </el-col>
      <el-col :span="12">
        <div class="home__wapper">
          <Notice />
        </div>
      </el-col>
    </el-row>

    <el-row  v-if="dl_type!='4'" type="flex" align="center" class="home__row home__fix">
      <el-col :span="19">
        <div class="home__wapper">
          <Trade />
        </div>
      </el-col>
      <el-col :span="5">
        <div class="home__wapper">
          <Shortcut />
        </div>
      </el-col>
    </el-row>

    <el-row  v-if="dl_type=='4'" type="flex" align="center" class="home__row home__fix">
      <el-col :span="24">
        <div class="home__wapper">
          <Trade />
        </div>
      </el-col>
    </el-row>

    <el-row type="flex" align="center" class="home__row home__fix">
      <el-col :span="12">
        <div class="home__wapper home__chart">
          <NormalToggleChart />
        </div>
      </el-col>
      <el-col :span="12">
        <div class="home__wapper home__chart">
          <PayAccessChart />
        </div>
      </el-col>
    </el-row>
  </d2-container>
</template>

<script>
import Trade from './components/Trade'
import OverView from './components/OverView'
import Notice from './components/Notice'
import Shortcut from './components/Shortcut'
import NormalToggleChart from './components/NormalToggleChart'
import PayAccessChart from './components/PayAccessChart'
import util from '@/libs/util.js'
export default {
  components: {
    Trade,
    Notice,
    Shortcut,
    OverView,
    PayAccessChart,
    NormalToggleChart
  },
  data () {
    return {
      dl_type: util.cookies.get('dl_type'),
      is_ygs: util.cookies.get('is_ygs'),
      toolbox: {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
